import {
  AssignModel,
  createClient,
  IdPathParameters,
  OwnerResponse,
  postRequestFactory,
  SaveOperation,
  SearchOperation,
  searchRequestFactory
} from '@infuse/api/common';

const client = createClient('/rest/authorization/local/token');

export const localTokenAccessManagementPermissions = {
  ASSIGN: 'cpms.assign-local-token',
  UNASSIGN: 'cpms.unassign-local-token',
  SEARCH_OWNERS: 'cpms.search-local-token-owners'
};

export type AssignLocalTokenRequest = AssignModel;
export type UnassignLocalTokenRequest = AssignModel;

export const assignLocalToken: SaveOperation<AssignLocalTokenRequest, void, string> = postRequestFactory<
  AssignLocalTokenRequest,
  void
>(client, {
  pattern: '/{id}/assign',
  permissionId: localTokenAccessManagementPermissions.ASSIGN
});

export const unassignLocalToken: SaveOperation<UnassignLocalTokenRequest, void, string> = postRequestFactory<
  UnassignLocalTokenRequest,
  void
>(client, {
  pattern: '/{id}/unassign',
  permissionId: localTokenAccessManagementPermissions.UNASSIGN
});

export const getLocalTokenOwners: SearchOperation<OwnerResponse, IdPathParameters<string>> = searchRequestFactory<
  OwnerResponse,
  IdPathParameters<string>
>(client, {
  pattern: '/{id}/owners',
  permissionId: localTokenAccessManagementPermissions.SEARCH_OWNERS
});
